import { render, staticRenderFns } from "./salesReturnTask.vue?vue&type=template&id=4fa55c26&scoped=true"
import script from "./salesReturnTask.vue?vue&type=script&lang=js"
export * from "./salesReturnTask.vue?vue&type=script&lang=js"
import style0 from "./salesReturnTask.vue?vue&type=style&index=0&id=4fa55c26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa55c26",
  null
  
)

export default component.exports